import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';

function GoogleAppointmentControls({ campaignId, config, onChange }) {
  const [status, setStatus] = useState(null);
  const [calendars, setCalendars] = useState([]);
  const [calendarId, setCalendarId] = useState(config.externalAccountId || 'primary');
  const [eventType, setEventType] = useState(config.eventType || '');
  const [matchMode, setMatchMode] = useState(config.eventTitleMatchMode || 'contains');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const response = await api.get('/agent/meeting-integrations/google/status');
      setStatus(response.data);
      if (response.data.calendarPermission) {
        const calendarsResponse = await api.get('/agent/meeting-integrations/google/calendars');
        setCalendars(calendarsResponse.data.calendars || []);
      }
      setError('');
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setCalendarId(config.externalAccountId || 'primary'); setEventType(config.eventType || ''); setMatchMode(config.eventTitleMatchMode || 'contains'); }, [config.externalAccountId, config.eventType, config.eventTitleMatchMode]);

  const grantAccess = async () => {
    setBusy(true); setError('');
    try {
      const response = await api.post('/agent/meeting-integrations/google/start', { returnPath: `/campaigns/${campaignId}/agent` });
      window.location.assign(response.data.url);
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); setBusy(false); }
  };

  const saveSelection = async () => {
    if (!calendarId || !eventType || !config.bookingUrl) { setError('Kies een kalender, vul de afspraaknaam in en voeg de openbare Google Appointment Schedule-link toe.'); return; }
    setBusy(true); setError('');
    try {
      const response = await api.patch(`/agent/campaigns/${campaignId}/google-appointment-schedule`, { calendarId, eventType, eventTitleMatchMode: matchMode, bookingUrl: config.bookingUrl });
      onChange({ ...config, ...response.data.config });
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };

  const syncNow = async () => {
    setBusy(true); setError('');
    try { await api.post(`/agent/campaigns/${campaignId}/google-appointment-schedule/sync`); }
    catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };

  return <div className="meeting-provider-native-panel">
    <div className="meeting-provider-native-head">
      <div><strong>Google Appointment Schedules</strong><p>Leadgenflow herkent geboekte afspraken via de Google Agenda waarin de Appointment Schedule de booking plaatst.</p></div>
      {!status?.calendarPermission
        ? <button className="campaign-agent-button secondary" disabled={busy} onClick={grantAccess}>{busy ? 'Doorsturen…' : status?.connected ? 'Agenda-toegang verlenen' : 'Google koppelen'}</button>
        : <span className="calendly-connected-badge">Agenda actief</span>}
    </div>
    {error && <div className="planner-warning">{error}</div>}
    {status?.calendarPermission && <div className="meeting-provider-native-grid">
      <label>Agenda<select value={calendarId} onChange={(e) => setCalendarId(e.target.value)}><option value="primary">Primaire agenda</option>{calendars.filter((item) => item.id !== 'primary').map((item) => <option key={item.id} value={item.id}>{item.summary}</option>)}</select></label>
      <label>Agenda-eventnaam<input value={eventType} onChange={(e) => setEventType(e.target.value)} placeholder="Bijv. Productdemo" /></label>
      <label>Match eventnaam<select value={matchMode} onChange={(e) => setMatchMode(e.target.value)}><option value="contains">Bevat tekst</option><option value="exact">Exact gelijk</option></select></label>
      <div className="meeting-provider-native-actions"><button className="campaign-agent-button secondary" disabled={busy || !calendarId || !eventType || !config.bookingUrl} onClick={saveSelection}>Gebruik voor campagne</button>{config.provider === 'google_appointment_schedule' && <button className="campaign-agent-button secondary" disabled={busy} onClick={syncNow}>Nu synchroniseren</button>}</div>
    </div>}
  </div>;
}

export default GoogleAppointmentControls;
